var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'd-flex text-h4 text-md-h3 text-uppercase font-weight-bold',
    _vm.dark ? 'white--text' : 'primary--text',
    _vm.className ]},[_c('div',[_c('div',{staticClass:"font-secondary"},[_vm._t("default")],2),_c('v-sheet',{staticClass:"mt-3 mt-md-4",class:{ 'mx-auto': _vm.align === 'center' },attrs:{"color":_vm.dark ? 'white' : 'primary',"width":"85px","height":"3px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }